export function cleanupPhoneNumber(localPhoneNumber: string): string {
  const matches = localPhoneNumber.match(/\d+/g);

  return matches ? matches.join("") : "";
}
